import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function CheckOut() {
    const [step, setStep] = useState(1); // 1: Questionário, 2: Seleção
    const [sectors, setSectors] = useState([]);
    const [beds, setBeds] = useState([]);
    const [formData, setFormData] = useState({
        sectorId: '',
        bedId: '',
        patientName: '',
        dischargeReason: 'alta_melhorada' // [Novo] Default
    });
    const [questions, setQuestions] = useState({
        belongingsChecked: false,
        summaryDelivered: false
    });
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Carregar setores ao iniciar
        const fetchSectors = async () => {
            try {
                const response = await api.get('/sectors');
                setSectors(response.data);
            } catch (error) {
                console.error('Erro ao carregar setores:', error);
            }
        };
        fetchSectors();
    }, []);

    // Carregar leitos quando setor muda
    useEffect(() => {
        if (formData.sectorId) {
            const fetchBeds = async () => {
                try {
                    const response = await api.get('/beds');
                    console.log('Todos os leitos:', response.data);

                    // Filtrar APENAS leitos ocupados (Status 5 = Em uso)
                    // Check-out só deve ser feito em leitos que têm pacientes
                    const occupiedBeds = response.data.filter(
                        bed => bed.sectorId == formData.sectorId && bed.statusId === 5
                    );

                    console.log(`Leitos ocupados no setor ${formData.sectorId}:`, occupiedBeds);
                    console.log(`Total de leitos ocupados: ${occupiedBeds.length}`);

                    if (occupiedBeds.length === 0) {
                        console.warn('Nenhum leito ocupado encontrado neste setor!');
                    }

                    setBeds(occupiedBeds);
                } catch (error) {
                    console.error('Erro ao carregar leitos:', error);
                }
            };
            fetchBeds();
        } else {
            setBeds([]);
        }
    }, [formData.sectorId]);

    const handleQuestionChange = (question, value) => {
        setQuestions(prev => ({ ...prev, [question]: value === 'yes' }));
    };

    const handleNextStep = () => {
        if (questions.belongingsChecked && questions.summaryDelivered) {
            setStep(2);
        } else {
            alert('Você precisa confirmar todos os itens de segurança para prosseguir.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.bedId) return;

        setLoading(true);
        try {
            await api.post('/service-alerts/checkout', {
                bedId: parseInt(formData.bedId),
                sectorId: parseInt(formData.sectorId),
                dischargeReason: formData.dischargeReason // [Novo]
            });

            alert('Alta registrada com sucesso! Solicitação de higienização enviada.');
            navigate('/');
        } catch (error) {
            console.error('Erro no check-out:', error);
            alert('Erro ao realizar check-out: ' + (error.response?.data?.error || error.message));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4 pb-20 md:pb-4 pb-safe">
            <div className="card shadow">
                <div className="card-header bg-danger text-white">
                    <h3 className="mb-0"><i className="bi bi-box-arrow-right me-2"></i>Check-out / Alta Hospitalar</h3>
                </div>
                <div className="card-body">

                    {step === 1 && (
                        <div className="animate__animated animate__fadeIn">
                            <h5 className="mb-4">Protocolo de Segurança de Alta</h5>

                            <div className="mb-4 p-3 border rounded bg-light">
                                <label className="form-label fw-bold">1. Pertences do Paciente:</label>
                                <p>Todos os pertences pessoais do paciente foram conferidos e retirados do quarto?</p>
                                <div className="btn-group" role="group">
                                    <input
                                        type="radio" className="btn-check" name="q1" id="q1_yes" autoComplete="off"
                                        onChange={() => handleQuestionChange('belongingsChecked', 'yes')}
                                    />
                                    <label className="btn btn-outline-success" htmlFor="q1_yes">SIM</label>

                                    <input
                                        type="radio" className="btn-check" name="q1" id="q1_no" autoComplete="off"
                                        onChange={() => handleQuestionChange('belongingsChecked', 'no')}
                                    />
                                    <label className="btn btn-outline-danger" htmlFor="q1_no">NÃO</label>
                                </div>
                            </div>

                            <div className="mb-4 p-3 border rounded bg-light">
                                <label className="form-label fw-bold">2. Sumário de Alta:</label>
                                <p>O sumário de alta foi preenchido, assinado e entregue ao paciente/acompanhante?</p>
                                <div className="btn-group" role="group">
                                    <input
                                        type="radio" className="btn-check" name="q2" id="q2_yes" autoComplete="off"
                                        onChange={() => handleQuestionChange('summaryDelivered', 'yes')}
                                    />
                                    <label className="btn btn-outline-success" htmlFor="q2_yes">SIM</label>

                                    <input
                                        type="radio" className="btn-check" name="q2" id="q2_no" autoComplete="off"
                                        onChange={() => handleQuestionChange('summaryDelivered', 'no')}
                                    />
                                    <label className="btn btn-outline-danger" htmlFor="q2_no">NÃO</label>
                                </div>
                            </div>

                            <button
                                className="btn btn-primary btn-lg w-100"
                                onClick={handleNextStep}
                                disabled={!questions.belongingsChecked || !questions.summaryDelivered}
                            >
                                Confirmar e Prosseguir
                            </button>
                        </div>
                    )}

                    {step === 2 && (
                        <form onSubmit={handleSubmit} className="animate__animated animate__fadeIn">
                            <button
                                type="button"
                                className="btn btn-link mb-3 text-secondary"
                                onClick={() => setStep(1)}
                            >
                                <i className="bi bi-arrow-left"></i> Voltar ao questionário
                            </button>

                            <div className="row mb-3">
                                <div className="col-md-6">
                                    <label className="form-label">Unidade / Setor</label>
                                    <select
                                        className="form-select"
                                        value={formData.sectorId}
                                        onChange={e => setFormData({ ...formData, sectorId: e.target.value, bedId: '' })}
                                        required
                                    >
                                        <option value="">Selecione o Setor</option>
                                        {sectors.map(sector => (
                                            <option key={sector.id} value={sector.id}>{sector.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">Leito para Alta</label>
                                    <select
                                        className="form-select"
                                        value={formData.bedId}
                                        onChange={e => setFormData({ ...formData, bedId: e.target.value })}
                                        required
                                        disabled={!formData.sectorId}
                                    >
                                        <option value="">Selecione o Leito</option>
                                        {beds.map(bed => (
                                            <option key={bed.id} value={bed.id}>{bed.number}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* [Novo] Motivo da Alta */}
                            <div className="mb-4">
                                <label className="form-label fw-bold">Motivo da Saída</label>
                                <select
                                    className="form-select form-select-lg"
                                    value={formData.dischargeReason}
                                    onChange={e => setFormData({ ...formData, dischargeReason: e.target.value })}
                                    required
                                >
                                    <option value="alta_melhorada">Alta Médica (Melhoria)</option>
                                    <option value="obito">Óbito</option>
                                    <option value="transferencia_externa">Transferência para Outra Unidade (Externa)</option>
                                    <option value="transferencia_interna">Transferência Interna (Outro Setor)</option>
                                    <option value="evasao">Evasão / Alta a Pedido</option>
                                </select>
                            </div>

                            <div className="alert alert-info">
                                <i className="bi bi-info-circle me-2"></i>
                                Ao confirmar, o leito mudará para <strong>Aguardando Higienização</strong>.
                                {(formData.dischargeReason === 'obito' || formData.dischargeReason === 'infeccao') && (
                                    <div className="mt-2 text-danger fw-bold">
                                        <i className="bi bi-exclamation-triangle me-2"></i>
                                        ATENÇÃO: Será solicitado protocolo de Limpeza Terminal Rigorosa.
                                    </div>
                                )}
                            </div>

                            <div className="d-grid gap-2 mt-4">
                                <button
                                    type="submit"
                                    className="btn btn-danger btn-lg"
                                    disabled={loading}
                                >
                                    {loading ? 'Processando...' : 'Alta - Portaria'}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
}
